export default {
  getSlug (obj) {
    const separator = obj.section_id ? 'articles' : 'sections'
    const slug = obj.html_url.split(`/${separator}/`)[1].replace(/-$/, '')
    return decodeURIComponent(slug)
  }
}
